import cx from 'clsx';
import React, { memo, useMemo } from 'react';

import { useCurrentAddressInfo } from '@/hooks';
import { isContractByUserDesc } from '@/utils';

import RankingTag from './RankingTag';
import SnsList from './SnsTag';
import style from './index.module.css';

interface SocialTagProps {
  addrInfo: UserInfo; // 查看的人
  editable?: boolean; // 备注是否可修改
  enableRankingLink?: boolean;
  gaCategory?: string;
}

export const SocialTag = memo(
  ({ addrInfo, enableRankingLink = false, gaCategory }: SocialTagProps) => {
    const { address, userInfo } = useCurrentAddressInfo();
    const isContract = isContractByUserDesc(addrInfo.desc);
    const isCurrentUser = useMemo(() => address === addrInfo.id, [address, addrInfo]);

    return isContract ? null : (
      <div className={cx(style.tags, !!userInfo?.rank_at ? style.hasRank : style.noRank)}>
        <RankingTag
          enableRankingLink={enableRankingLink}
          className={cx(style.tag, style.rankingTag)}
          address={addrInfo.id}
        />
        <SnsList addrInfo={addrInfo} isCurrentUser={isCurrentUser} gaCategory={gaCategory} />
      </div>
    );
  },
);

export default SocialTag;
